import {Component, OnInit, ViewChild} from '@angular/core';
import {LocalStorageService} from 'ng2-webstorage';
import {MessageService} from 'primeng/components/common/messageservice';
import {ConfirmationService, Paginator} from 'primeng/primeng';
import {ParentChildService} from '../../../../../components/parentchild/parentchild.service';
import {DataAnalyticsService} from '../../../../../components/dataAnalytics/dataAnalytics.service';

@Component({
  selector: 'app-student-profile',
  templateUrl: './student-registration.component.html',
  styleUrls: ['./student-registration.component.css']
})

export class StudentRegistrationComponent implements OnInit {
  public schoolId: any;
  display = "none"
  public info:boolean=false;
  //public userId: any;


  public SchoolYear: any;
  public selectedYear: string = '';


  public HigherEdchildcourse: any;
  public HigherEdchildBatch: any;
  public selectedCourse: string = '';
  public ShowLevelData: any;
  public selectedlevel: string = '';
  public grade: any = [];
  public section: any;
  public selectedgrade:  any;
  public selectedsection:  any;






  public selectedbatch: string = '';
  public studentfname: string = '';
  public studentmname: string = '';
  public studentlname: string = '';
  public studentdob: string = '';
  public studentnic: string = '';
  public studentemail: string = '';

  //public Genderid: number;
  public studentgender: string = '';


  public studentphone: string = '';
  public studentcreateddate: Date = new Date();
  public studentModifieddate: Date = new Date();
  public stucreatedby: string = ''
  public stumodifiedby: string = ''
  public stustatusid: any =1;
  public studentcode: string = '';

  public SelectedAcademicYearId: any;
  public Selectedregisterationnumber: string = '';
  public SelectedParentFirstname: string = '';
  public SelectedParentLastname: string = '';
  public SelectedParentMiddlename: string = '';
  public SelectedParentDob:  string = '';
  public SelectedParentPhonenumber: string = '';
  public SelectedParentGenderid: string = '0';
  public SelectedParentEmailid: string = '';
  public SelectedParentPassword: string = '';

  public SelectedParentIshigheduser:  string = '';
  public SelectedParentIssmsuser:  string = '';


  public SelectedParent2Firstname: string = '';
  public SelectedParent2Lastname: string = '';
  public SelectedParent2Middlename: string = '';
  public SelectedParent2Dob:  string = '';
  public SelectedParent2Phonenumber: string = '';
  public SelectedParent2Genderid: string = '1';
  public SelectedParent2Emailid: string = '';
  public SelectedParent2Password: string = '';

  public SelectedParent2Ishigheduser:  string = '';
  public SelectedParent2Issmsuser:  string = '';


  yearId: any = [];
  yearname: any = [];
  YearData: any = [];
  public mappedData: any;
  selectedGrade: any;
  selectedSection: any = [];
  sectionList: any = [];
  nameofsec: any = [];
  sectionId: any = []

  selectedYearId: any;

  userId: any;





  constructor(private messageService: MessageService,
              private dataAnalyticsservice: DataAnalyticsService,
              private parentchildservice: ParentChildService,
              private confirmationService: ConfirmationService,
              private localStorage: LocalStorageService)
  {
    this.schoolId = this.localStorage.retrieve('schoolid');
    this.userId = this.localStorage.retrieve('id');
  }

  ngOnInit() {
    this.schoolId = this.localStorage.retrieve('schoolid');
    this.userId = this.localStorage.retrieve('id');
    this.getYearData();
    this.getLevelsName();

  }


  private getYearData() {
    this.dataAnalyticsservice.getYear()._finally(() => { }).subscribe(
      response => {
        this.YearData = response['yearList'];
        // console.log(this.YearData);
        this.yearId = this.YearData[0].YearId;
        console.log(this.yearId);
        try {
          this.selectedYear = this.YearData[0];
        } catch (error) {

        }

        // console.log(response )
      }
    )
  }

  getYearList(year) {
    console.log(year)
    this.yearId = year.YearId;
    this.yearname = year.AcademicYear;

    console.log(this.yearname);
    console.log(this.yearId);

  }


  getLevelsListById(){
    console.log("fffff", this.selectedlevel);
    this.getLevelClassSection(this.selectedlevel);
  }


  private getLevelClassSection(lid) {
    this.dataAnalyticsservice.GetLevelStandardSectionMapping(lid).finally(() => { }).subscribe(
      response => {
        let mappedData: any = response;
        mappedData.forEach(standard => {
          standard['Sections'].forEach(section => {
            section['StdId'] = standard['standardId'];
            section['StdName'] = standard['standardsName'];
            section['selected'] = false;
          });
        });
        console.log("mappedData", mappedData);
        mappedData.sort((a, b) => ("" + a.standardsName).localeCompare(b.standardsName, undefined, { numeric: true }));
        if (true) {
          this.mappedData = mappedData;

        }

        try {
          this.selectedGrade = mappedData[mappedData.length - 1];
          this.getSectionByGrade(this.selectedGrade);
          this.selectedSection = this.selectedGrade.Sections[0];
        } catch (error) {
          //window.location.reload();
        }
        try {
          this.nameofsec = this.selectedSection.sectionName;
          this.sectionId = this.selectedSection.SectionId;
        } catch (error) {

        }
      },
      error => {
        this.mappedData = [];
        this.sectionList = [];
        this.selectedGrade = null;
        this.selectedSection = null;
      });
  };


  getSectionByGrade(grade) {
    this.sectionList = grade.Sections;
    this.sectionList.sort((a, b) => {
      if (a.sectionName.toLowerCase() < b.sectionName.toLowerCase()) {
        return -1;
      }
      if (a.sectionName.toLowerCase() > b.sectionName.toLowerCase()) {
        return 1;
      }
      return 0;
    });
    try {
      this.selectedSection = this.sectionList[0];
    } catch (error) {

    }
  }

  getGclClassesListById(section) {
    this.nameofsec = section.sectionName;
    this.sectionId = section.SectionId;
    console.log('getGclClassesListById', this.sectionId);
  }


  private getLevelsName() {
    this.dataAnalyticsservice
      .getLevel()
      ._finally(() => {})
      .subscribe((response) => {
        this.ShowLevelData = response;
        try {
          this.selectedlevel =  this.ShowLevelData[0].Id;
          //this.getClassSection(this.selectedlevel["Id"]);
          this.getLevelClassSection(this.selectedlevel);

        } catch (error) {

        }
        console.log("ShowLevelData", this.ShowLevelData);
      }, (error) => {

      });
  }


//--------------------------------------------------------------------------------------

  postStudentInfo() {
    //this.Genderid = parseInt(this.studentgender, 10);

    var payload = {
      Code: this.studentcode,
      Firstname: this.studentfname,
      Lastname: this.studentlname,
      Middlename: this.studentmname,
      Dob: this.studentdob,
      Phonenumber: `+94${this.studentphone}`,
      Genderid: this.studentgender,
      Createddate: this.studentcreateddate,
      Modifieddate: this.studentModifieddate,
      Createdby: this.userId,
      Modifiedby: this.userId,
      Statusid: this.stustatusid,
      Email: this.studentemail,
      Nic: this.studentnic,
      StandardsectionmappingId: this.sectionId,
      AcademicYearId: this.yearId,
      registerationnumber: this.Selectedregisterationnumber,

      ParentFirstname: this.SelectedParentFirstname,
      ParentLastname: this.SelectedParentLastname,
      ParentMiddlename: this.SelectedParentMiddlename,
      ParentDob: this.SelectedParentDob,
      ParentPhonenumber: `+94${this.SelectedParentPhonenumber}`,
      ParentGenderid: this.SelectedParentGenderid,
      ParentEmailid: this.SelectedParentEmailid,
      ParentPassword: this.SelectedParentPassword,
      ParentIssmsuser: this.SelectedParentIssmsuser == "true" ? true: false,
      ParentIshigheduser: this.SelectedParentIshigheduser == "true" ? true: false,

      Parent2Firstname: this.SelectedParent2Firstname,
      Parent2Lastname: this.SelectedParent2Lastname,
      Parent2Middlename: this.SelectedParent2Middlename,
      Parent2Dob: this.SelectedParent2Dob,
      Parent2Phonenumber: `+94${this.SelectedParent2Phonenumber}`,
      Parent2Genderid: this.SelectedParent2Genderid,
      Parent2Emailid: this.SelectedParent2Emailid,
      Parent2Password: this.SelectedParent2Password,
      Parent2Issmsuser: this.SelectedParent2Issmsuser == "true" ? true: false,
      Parent2Ishigheduser: this.SelectedParent2Ishigheduser == "true" ? true: false,
    };


    // Assuming payload is the object you're working with
    payload.Dob = payload.Dob === "" ? null : payload.Dob;
    payload.ParentDob = payload.ParentDob === "" ? null : payload.ParentDob;
    payload.Parent2Dob = payload.Parent2Dob === "" ? null : payload.Parent2Dob;

    // console.log(payload);



    if((!this.studentfname ||
      !this.studentlname ||
      !this.studentgender)){

      this.messageService.add({
        severity: "error",
        summary: "Validation Error",
        detail: "Please enter required student details (first name, last name, DOB, Gender)",
      });
      return;
    }
    else if (
      (
        !this.SelectedParentPhonenumber ||
        !this.SelectedParentFirstname ||
        !this.SelectedParentLastname
      ) &&
      (
        !this.SelectedParent2Phonenumber ||
        !this.SelectedParent2Firstname ||
        !this.SelectedParent2Lastname
      )
    )
    {
      this.messageService.add({
        severity: "error",
        summary: "Validation Error",
        detail: "At least one parent's details (first name, last name, mobile number) must be provided.",
      });
      return;
    } else {
      console.log("postStudentInfo",payload);

      this.parentchildservice
        .postHiEduChildandTeacherInfo(payload)
        .finally(() => {})
        .subscribe(
          (response) => {
            this.messageService.add({
              severity: "success",
              summary: "Talkative Parents",
              detail: "Student Added Successfully",
            });
            this.display = "none";
            //this.ShowCourse();
            this.clearFormData();

            console.log(response);
          },
          (error) => {}
        );
    }
  };

  clearFormData() {
    this.selectedCourse ='';
    this.studentcode = '';
    this.studentfname = '';
    this.studentlname = '';
    this.studentmname = '';
    this.studentdob = '';
    this.studentphone = '';
    this.studentgender = '';
    this.studentcreateddate = new Date();
    this.studentModifieddate = new Date();
    this.studentemail = '';
    this.studentnic = '';
    this.Selectedregisterationnumber = '';
    this.SelectedParentFirstname = '';
    this.SelectedParentLastname = '';
    this.SelectedParentMiddlename = '';
    this.SelectedParentDob  = '';
    this.SelectedParentPhonenumber = '';
    this.SelectedParentGenderid = '';
    this.SelectedParentEmailid = '';
    this.SelectedParentPassword = '';
    this.SelectedParentIssmsuser = '';
    this.SelectedParentIshigheduser = '';

    this.SelectedParent2Firstname = '';
    this.SelectedParent2Lastname = '';
    this.SelectedParent2Middlename = '';
    this.SelectedParent2Dob  = '';
    this.SelectedParent2Phonenumber = '';
    this.SelectedParent2Genderid = '';
    this.SelectedParent2Emailid = '';
    this.SelectedParent2Password = '';
    this.SelectedParent2Issmsuser = '';
    this.SelectedParent2Ishigheduser = '';
  }

  //----------------------------------------------------------------------------------------------

  roleinfo(){
    this.info=true;
  }


  editSemsub(semsub){


    // this.display = true;
    this.display = "block";
  }



  addSemsub() {

    this.display= "block"
    // this.display = true;
  }
  onCloseHandled() {
    this.display= "none";
  }



}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/student-details/student-registration/student-registration.component.ts